import {
  Box,
  VStack,
  IconButton,
  Text,
  Button,
  Divider,
  Tooltip,
} from '@chakra-ui/react'
import { 
  FiChevronLeft, 
  FiChevronRight, 
  FiPlus, 
  FiRefreshCw,
  FiFilter,
  FiSettings
} from 'react-icons/fi'

interface AgentSidebarProps {
  isOpen: boolean
  onToggle: () => void
  onNewAgent: () => void
  activeAgentsCount: number
}

export const AgentSidebar = ({ isOpen, onToggle, onNewAgent, activeAgentsCount }: AgentSidebarProps) => {
  return (
    <Box
      position="relative"
      w={isOpen ? "250px" : "0"}
      transition="width 0.2s"
      overflow="visible"
    >
      <IconButton
        aria-label="Toggle Sidebar"
        icon={isOpen ? <FiChevronRight size={24} /> : <FiChevronLeft size={24} />}
        position="absolute"
        left={isOpen ? "-16px" : "-40px"}
        top="50%"
        transform="translateY(-50%)"
        borderRadius="full"
        size="md"
        onClick={onToggle}
        zIndex="1"
        bg="white"
        boxShadow="md"
      />

      {isOpen && (
        <Box
          h="100%"
          bg="white"
          borderRadius="lg"
          boxShadow="md"
          overflow="hidden"
        >
          <VStack p={4} spacing={4} align="stretch">
            <Text fontSize="lg" fontWeight="bold">Actions</Text>
            
            <Button
              leftIcon={<FiPlus />}
              colorScheme="blue"
              onClick={onNewAgent}
            >
              New Agent
            </Button>

            <Divider />

            <Text fontSize="lg" fontWeight="bold">Tools</Text>

            <VStack spacing={2} align="stretch">
              <Tooltip label="Refresh Agents" placement="left">
                <Button
                  leftIcon={<FiRefreshCw />}
                  variant="ghost"
                  justifyContent="flex-start"
                >
                  Refresh
                </Button>
              </Tooltip>

              <Tooltip label="Filter Agents" placement="left">
                <Button
                  leftIcon={<FiFilter />}
                  variant="ghost"
                  justifyContent="flex-start"
                >
                  Filter
                </Button>
              </Tooltip>

              <Tooltip label="Agent Settings" placement="left">
                <Button
                  leftIcon={<FiSettings />}
                  variant="ghost"
                  justifyContent="flex-start"
                >
                  Settings
                </Button>
              </Tooltip>
            </VStack>

            <Divider />

            <Text fontSize="sm" color="gray.500">
              Active Agents: {activeAgentsCount}
            </Text>
          </VStack>
        </Box>
      )}
    </Box>
  )
} 